export const MOCK_CARDS_LIMIT = 'cards_limit'
export const MOCK_ACTIVATION_CUSTOM_ERROR_CODE = 'activation_custom_error_code'
